// Removes Persian/Arabic letters (and Persian/Arabic digits) from credential fields.
export const stripPersian = (s) =>
  s.replace(/[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿]/g, '');
